import { DatePipe } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AppConfig } from 'src/app/app.config';
import { StreamStatusEnum } from 'src/app/enums/stream-status.enum';
import { IRecentlyAiredSchedule } from 'src/app/models/recently-aired-items.model';
import { ShopService } from 'src/app/services/shop.service';
import { AuthenticationService } from '../../services/authentication.service';

@Component({
  selector: 'recently-viewed-items',
  templateUrl: '../../views/home/recently-viewed.home.component.html',
  styleUrls: ['../../../assets/css//home/recently-viewed.home.component.css'],
})
export class RecentlyViewedItemsComponent implements OnInit, OnDestroy {
  schedules: IRecentlyAiredSchedule[] = [];
  private subscriptions = new Subscription();

  startIndex: number = 0;
  endIndex: number = 3;

  constructor(
    private shopService: ShopService,
    private authservice: AuthenticationService,
    private datePipe: DatePipe
  ) {}

  ngOnInit(): void {
    this.subscriptions.add(
      this.shopService
        .allSchedulesInRecentlyViewed(this.authservice.currentUserId)
        .subscribe((list: IRecentlyAiredSchedule[]) => {
          this.schedules = list;
        })
    );
  }

  parseApiImageUrl(url: string): string {
    return url;
  }

  hasInProgressStatus(statusEnumValue: StreamStatusEnum): boolean {
    return statusEnumValue == StreamStatusEnum.IN_PROGRESS;
  }

  indexBetweenRange(index) {
    if (index >= this.startIndex && index <= this.endIndex) {
      return true;
    }

    return false;
  }

  displayNextItems() {
    if (this.endIndex + 1 > this.schedules.length) {
      this.startIndex = 0;
      this.endIndex = 3;
      return;
    }

    this.startIndex = this.startIndex + 1;
    this.endIndex = this.endIndex + 1;
  }

  displayPrevItems() {
    if (this.startIndex - 1 < 0) {
      this.startIndex = this.schedules.length - 4;
      this.endIndex = this.schedules.length - 1;
      return;
    }

    this.startIndex = this.startIndex - 1;
    this.endIndex = this.endIndex - 1;
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
